module.exports = __webpack_public_path__ + "static/media/faqBalance-en-pt.e0a550ba.vtt";